module.exports = __webpack_public_path__ + "img/ITAU.9b82f7d.png";